<app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>

<div class="grid grid-cols-1 gap-6">
  <app-component-card [title]="pageTitle" desc="Complete los datos del atributo de lead">

    <!-- Error -->
    @if (error) {
    <div class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
    }

    <!-- Duplicate Name Error -->
    @if (duplicateNameError) {
    <div class="mb-4 p-4 bg-warning-50 border border-warning-200 rounded-lg dark:bg-warning-500/10 dark:border-warning-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-warning-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
        <p class="text-warning-600 dark:text-warning-400">{{ duplicateNameError }}</p>
      </div>
    </div>
    }

    <!-- Formulario -->
    <form (ngSubmit)="guardar()" #attributeForm="ngForm" class="space-y-5">

      <!-- Nombre de Campo (attributeName) -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Nombre de Campo <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          name="attributeName"
          [(ngModel)]="attributeName"
          (ngModelChange)="onAttributeNameChange($event)"
          required
          maxlength="30"
          placeholder="ej: score_credito"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.border-warning-500]="attributeNameValidationError || duplicateNameError"
        />
        @if (attributeNameValidationError) {
        <p class="mt-1.5 text-sm text-warning-600 dark:text-warning-400 flex items-center gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          {{ attributeNameValidationError }}
        </p>
        } @else {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ attributeName.length }}/30 caracteres</p>
        }
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Identificador interno del campo (sin espacios, preferiblemente en snake_case)</p>
      </div>

      <!-- Etiqueta (displayName) -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Etiqueta <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          name="displayName"
          [(ngModel)]="displayName"
          (ngModelChange)="onDisplayNameChange($event)"
          required
          maxlength="30"
          placeholder="ej: Score Crediticio"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.border-warning-500]="displayNameValidationError"
        />
        @if (displayNameValidationError) {
        <p class="mt-1.5 text-sm text-warning-600 dark:text-warning-400 flex items-center gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          {{ displayNameValidationError }}
        </p>
        } @else {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ displayName.length }}/30 caracteres</p>
        }
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Nombre legible que se mostrará en la interfaz</p>
      </div>

      <!-- Tipo de Valor (valueType) -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Tipo de Valor <span class="text-error-500">*</span>
        </label>
        <select
          name="valueType"
          [(ngModel)]="valueType"
          required
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed">
          @for (option of valueTypeOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Define el tipo de dato que almacenará este atributo
        </p>
      </div>

      <!-- Info: solo creación -->
      <div class="p-3 bg-brand-50 border border-brand-200 rounded-lg dark:bg-brand-500/10 dark:border-brand-500/20">
        <div class="flex items-start gap-2">
          <svg class="w-4 h-4 text-brand-500 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <p class="text-xs text-brand-700 dark:text-brand-300">
            Los atributos no se pueden editar una vez creados. Para modificar un atributo, elimínelo y créelo nuevamente.
          </p>
        </div>
      </div>

      <!-- Botones -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button
          variant="outline"
          type="button"
          (btnClick)="cancelar()">
          Cancelar
        </app-button>
        <app-button
          variant="primary"
          type="submit"
          [disabled]="saving">
          {{ saving ? 'Guardando...' : 'Crear Atributo' }}
        </app-button>
      </div>
    </form>

  </app-component-card>
</div>
